// Csapat-jelölő badge — a GLOBÁLIS `Badge`-re épül (atomic: egy pill-primitív mindenhol), a MORGENS csapat-
// színnel (soft tónus + telített szöveg, mint a többi badge — lásd `teamBadgeStyle`). A szín-token a workforce
// `teams.color` (a RÉSZLEGNEK nincs színe). Ismeretlen/üres név → null (nem renderel). Bárhol újrahasználható
// (címtár, kártya, sheet).
import { Badge } from '@/components/ui/badge';
import { teamBadgeStyle } from '@/lib/team-colors';

export interface TeamBadgeProps {
  /** A csapat (lokalizált) neve; üres/null → nem renderel. */
  name: string | null | undefined;
  /** A csapat szín-tokenje (MORGENS-paletta); ismeretlen → gray. */
  color: string | null | undefined;
  className?: string;
}

export function TeamBadge({ name, color, className }: TeamBadgeProps): JSX.Element | null {
  if (!name) return null;
  return (
    <Badge className={className} style={teamBadgeStyle(color)}>
      {name}
    </Badge>
  );
}
